import { MouseEventHandler } from 'react';

import { Banner, Button, Flex, Text } from '@spotify-internal/encore-web';

import { ConfidenceLogo } from '../Icons';
import { ChartBackground } from './ChartBackground';
import { Footer } from './Footer';
import { LoginErrorMessage } from './LoginErrorMessage';

import styles from './TokenAccessRecovery.module.css';

export const TokenAccessRecovery = ({
  onRetry,
  onSignIn,
  error,
  retrying,
  signingIn,
}: {
  onRetry: MouseEventHandler<HTMLButtonElement>;
  onSignIn: MouseEventHandler<HTMLButtonElement>;
  error?: Error;
  retrying?: boolean;
  signingIn?: boolean;
}) => (
  <ChartBackground>
    <Flex
      className={styles.root}
      direction="column"
      alignItems="center"
      data-testid="token-access-recovery"
    >
      <Flex
        className={styles.main}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <ConfidenceLogo className={styles.logo} color="currentColor" />
        <Flex
          className={styles.content}
          direction="column"
          alignItems="center"
          gap="tighter"
        >
          <Text as="h1" variant="titleLarge">
            We couldn&apos;t sign you in to Confidence
          </Text>
          <Text as="p" variant="bodyMedium" semanticColor="textSubdued">
            Try again, or log in.
          </Text>
          <Flex
            className={styles.actions}
            direction="column"
            alignItems="center"
            gap="tighter-2"
          >
            <Button
              variant="primary"
              colorSet="inverted"
              size="large"
              fullWidth
              data-testid="retry-access-token"
              onClick={onRetry}
              disabled={signingIn}
              isLoading={retrying}
              loadingAriaLabel="Trying again"
             data-track-source-anchor="3f799a9eb6">
              Try again
            </Button>
            <Button
              variant="tertiary"
              size="small"
              semanticColor="textBase"
              data-testid="sign-in-access-token"
              onClick={onSignIn}
              disabled={retrying}
              isLoading={signingIn}
              loadingAriaLabel="Logging in"
             data-track-source-anchor="c7b3166a16">
              Log in
            </Button>
            {error && (
              <Banner colorSet="negative" contextual role="alert">
                <LoginErrorMessage error={error} />
              </Banner>
            )}
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  </ChartBackground>
);
